(() => {
  if (window.mcReviewsReady) { window.mcInitReviews?.(); return; }
  window.mcReviewsReady = true;
  const cleanups = new WeakMap();
  function init(root = document) {
    const sliders = root.matches?.('[data-review-slider]') ? [root] : root.querySelectorAll('[data-review-slider]');
    sliders.forEach(slider => {
      if (slider.dataset.ready) return;
      slider.dataset.ready = 'true';
      const track = slider.querySelector('[data-review-track]');
      const source = slider.querySelector('[data-review-source]');
      const pause = slider.querySelector('[data-review-pause]');
      const reviews = [...source.content.querySelectorAll('.jdgm-carousel-item')];
      if (!reviews.length) { slider.hidden = true; return; }
      const element = (tag, className, text) => {
        const node = document.createElement(tag); node.className = className;
        if (text) node.textContent = text;
        return node;
      };
      reviews.forEach(review => {
        const text = selector => review.querySelector(selector)?.textContent.trim() || '';
        const card = element('article', 'mc-story-card');
        card.dataset.reviewId = review.dataset.reviewId || '';
        const rating = review.querySelector('.jdgm-carousel-item__review-rating');
        const stars = element('div', 'mc-story-stars', '★'.repeat(rating?.querySelectorAll('.jdgm--on').length || 0));
        stars.setAttribute('role', 'img'); stars.setAttribute('aria-label', rating?.getAttribute('aria-label') || 'Customer rating');
        const quote = element('span', 'mc-story-quote', '“'); quote.setAttribute('aria-hidden','true');
        const title = element('h3', '', text('.jdgm-carousel-item__review-title'));
        const body = element('blockquote', '', text('.jdgm-carousel-item__review-body'));
        const author = text('.jdgm-carousel-item__reviewer-name') || 'Anonymous';
        const footer = element('div', 'mc-story-author');
        const avatar = element('span', 'mc-story-avatar', author.charAt(0).toUpperCase()); avatar.setAttribute('aria-hidden','true');
        const byline = element('div', 'mc-story-byline');
        byline.append(element('strong', '', author), element('span', '', 'Customer review'));
        footer.append(avatar, byline);
        const productImage = review.querySelector('.jdgm-carousel-item__product-image');
        if (productImage) {
          const img = document.createElement('img');
          img.src = productImage.dataset.srcRetina || productImage.dataset.src || productImage.src;
          img.alt = productImage.alt; img.loading = 'lazy'; img.width = 52; img.height = 60; img.draggable = false;
          footer.append(img);
        }
        card.append(stars, quote, title, body, footer);
        track.append(card);
      });

      // Repeat once for a continuous visual loop. Duplicates stay outside the accessibility tree.
      const originals = [...track.children];
      originals.forEach(card => {
        const clone = card.cloneNode(true); clone.dataset.clone = 'true';
        clone.setAttribute('aria-hidden', 'true'); clone.setAttribute('inert',''); track.append(clone);
      });
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = !pause || motion.matches, hovered = false, focused = false, dragging = false;
      let startX = 0, startScroll = 0, moved = false, loopWidth = 0, frame = 0, last = 0, visible = false;
      let resumeAt = 0, position = 0, pointerId = null;
      const canLoop = () => originals.length > 1 && loopWidth > track.clientWidth;
      function measure() {
        track.querySelectorAll('[data-clone]').forEach(card => { card.hidden = false; });
        loopWidth = track.children[originals.length].offsetLeft - originals[0].offsetLeft;
        track.querySelectorAll('[data-clone]').forEach(card => { card.hidden = !canLoop(); });
        if (pause) pause.hidden = !canLoop(); position = track.scrollLeft;
      }
      function updateButton() { if (!pause) return;
        pause.textContent = userPaused ? 'Play scrolling' : 'Pause scrolling';
        pause.setAttribute('aria-pressed', String(userPaused));
      }
      function normalize() {
        if (!canLoop()) return;
        if (track.scrollLeft >= loopWidth) track.scrollLeft -= loopWidth;
        position = track.scrollLeft;
      }
      pause?.addEventListener('click', () => { userPaused = !userPaused; updateButton(); });
      slider.addEventListener('mouseenter', () => { hovered = true; });
      slider.addEventListener('mouseleave', () => { hovered = false; });
      track.addEventListener('focusin', () => { focused = true; });
      track.addEventListener('focusout', () => { focused = false; });
      track.addEventListener('pointerdown', event => {
        resumeAt = performance.now() + 2500;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true; moved = false; pointerId = event.pointerId;
        startX = event.clientX; startScroll = track.scrollLeft;
        track.setPointerCapture(event.pointerId); track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', event => {
        if (!dragging || event.pointerId !== pointerId) return;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 5) moved = true;
        track.scrollLeft = startScroll - distance;
      });
      function endDrag() {
        dragging = false; pointerId = null; track.classList.remove('is-dragging');
        resumeAt = performance.now() + 2500; normalize();
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('lostpointercapture', endDrag);
      track.addEventListener('click', event => { if (moved) {event.preventDefault(); moved = false;} });
      track.addEventListener('wheel', () => { resumeAt = performance.now() + 2500; }, {passive:true});
      track.addEventListener('touchstart', () => { dragging = true; }, {passive:true});
      track.addEventListener('touchend', endDrag, {passive:true});
      track.addEventListener('touchcancel', endDrag, {passive:true});
      track.addEventListener('scroll', () => { if (!dragging) normalize(); else position = track.scrollLeft; }, {passive:true});
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const step = originals[0].getBoundingClientRect().width + 24;
        if (event.key === 'Home') track.scrollLeft = 0;
        else if (event.key === 'End') track.scrollLeft = Math.max(0, loopWidth - track.clientWidth);
        else track.scrollLeft += event.key === 'ArrowRight' ? step : -step;
      });
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, {threshold:0.1});
      observer.observe(slider);
      const resize = new ResizeObserver(measure); resize.observe(track);
      const motionChange = () => { userPaused = !pause || motion.matches; updateButton(); };
      motion.addEventListener('change', motionChange);
      function tick(now) {
        if (!slider.isConnected) { cleanup(); return; }
        const elapsed = Math.min(now - (last || now), 50); last = now;
        if (visible && !document.hidden && !userPaused && !hovered && !focused && !dragging && now > resumeAt && canLoop()) {
          position += elapsed * 0.025;
          if (position >= loopWidth) position -= loopWidth;
          track.scrollLeft = position;
        }
        frame = requestAnimationFrame(tick);
      }
      function cleanup() { cancelAnimationFrame(frame); observer.disconnect(); resize.disconnect(); motion.removeEventListener('change', motionChange); }
      cleanups.set(slider, cleanup);
      measure(); updateButton(); frame = requestAnimationFrame(tick);
    });
  }
  window.mcInitReviews = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  // Shopify's development preview can replace section HTML without re-running deferred scripts.
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1 && (node.matches('[data-review-slider]') || node.querySelector('[data-review-slider]'))) init(node);
    }));
  }).observe(document.documentElement, {childList:true, subtree:true});
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-review-slider]').forEach(slider => cleanups.get(slider)?.()));
})();
